<!-- 大屏右侧 数据层 -->
<template>
  <div class="display">
    <div class="row-1">
      <img
        class="task-font-bk1-1"
        src="../../../../static/img/display-img/show_new/bg_tit_all.png"
      />
      <div class="xietong">协同</div>
    </div>
    <div class="row-2">
	    <div v-for="(item, index) in coordination" :key="index" class="coordination-item" >
		    <div v-if="index < 4" class="coordination-item-box">
          <p>{{item.key}}</p>
          <span>{{item.value}} {{item.unit}}</span>
        </div>
        <div v-else class="coordination-item-box-long">
          <p>{{item.key}}</p>
          <span>{{item.value}} {{item.unit}}</span>
        </div>
	    </div>
    </div>
    <div class="row-3">
      <div class="area-chart-list">
        <div class="area-chart-item">
          <div class="area-chart-item-title">
            <img
              class="area-chart-item-title-bg"
              src="../../../../static/img/display-img/show_new/bg_tit_all.png"
            />
            <div class="area-chart-item-title-text">粪污处理</div>
          </div>
          <div class="area-chart-item-box">
            <div id="area-chart1" class="area-chart-item-content"></div>
          </div>
        </div>
        <div class="area-chart-item">
          <div class="area-chart-item-title">
            <img
              class="area-chart-item-title-bg"
              src="../../../../static/img/display-img/show_new/bg_tit_all.png"
            />
            <div class="area-chart-item-title-text">餐厨处理</div>
          </div>
          <div class="area-chart-item-box">
            <div id="area-chart2" class="area-chart-item-content"></div>
          </div>
        </div>
        <div class="area-chart-item">
          <div class="area-chart-item-title">
            <img
              class="area-chart-item-title-bg"
              src="../../../../static/img/display-img/show_new/bg_tit_all.png"
            />
            <div class="area-chart-item-title-text">堆肥处理</div>
          </div>
          <div class="area-chart-item-box">
            <div id="area-chart3" class="area-chart-item-content"></div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script>
import data from './assets/data.js';
import baseEcharts from './components/BaseEcharts';
export default {
  components: {},
  name: "rightDataDisplay",
  mixins: [data],
  data() {
    return {
      levelList: [],                      // 液位计
      isShow: true,                       // 显示
      // alarmType: '',
      // status: '',
      tableData: [],
      iconFlag: "",
      barChartData: "",
      showChart: true,
      unitid: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {},
  mounted() {
    baseEcharts('area-chart1', this.lineChart[0]);
    baseEcharts('area-chart2', this.lineChart[1]);
    baseEcharts('area-chart3', this.lineChart[2]);
   
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang='scss' scoped>
p{
  margin: 0;
}

.level-wrapper {
	position: relative;
	margin-right: 10px;
}
.img {
	width: 80px;
	height: 80px;
}
.name {
	color: #fff;
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.display {
  width: 418px;
  height: 840px;
  position: absolute;

}
.row-1,
.row-2,
.row-3,
.row-5,
.row-6,
.row-7 {
//  position: absolute;
	width: 100%;
}
.row-4 {
  position: absolute;
  width: 418px;
  height: 295px;
}
// -----图片部分------
.task-font-bk1-1 {
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 26px;
  margin: 113px 0px 0px 0px;
  left: 17px;
}
.xietong {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 26px;
  margin: 113px 0px 0px 0px;
  left: 34px;
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
}
.row-2 {
  position: absolute;
  width: 386px;
  height: 128px;
	display: flex;
  justify-content: space-between;
  align-content: space-between;
	flex-flow:row wrap;
	margin: 171px 0px 0px 0px;
  left: 28px;
  .coordination-item{
    .coordination-item-box,
    .coordination-item-box-long{
      height: 59px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      text-align: center;
      >p{
        height: 14px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
      }
      >span{
        font-size: 18px;
        font-weight: 400;
        color: #31FBFB;
      }
    }
    .coordination-item-box{
      width: 89px;
      background-image: url(../../../../static/img/display-img/show_new/bg_img_coordination01.png);
    }
    .coordination-item-box-long{
      width: 122px;
      background-image: url(../../../../static/img/display-img/show_new/bg_img_coordination02.png);
    }
  }
}
.area-chart-list{
  position: absolute;
  z-index: 100;
  width: 400px;
  height: 720px;
  margin: 338px 0px 0px 0px;
  left: 17px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .area-chart-item{
    width: 100%;
    height: 228px;
    .area-chart-item-title{
      width: 110px;
      height: 26px;
      .area-chart-item-title-bg{
        position: absolute;
        z-index: 100;
        width: 110px;
        height: 26px;
        left: 0px;
      }
      .area-chart-item-title-text{
        position: absolute;
        z-index: 100;
        width: 148px;
        height: 26px;
        left: 17px;
        text-align: left;
        font-size: 20px;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
    .area-chart-item-box{
      width: 100%;
      height: 200px;
      .area-chart-item-content{
        width: 100%;
        height: 200px;
      }
    }
  }
}
.task-font-bk2-1 {
  position: absolute;
  z-index: 100;
  width: 80px;
  height: 81px;
  margin: 139px 0px 0px 14px;
}
.task-font-bk2-2 {
  position: absolute;
  z-index: 100;
  width: 80px;
  height: 81px;
  margin: 139px 0px 0px 128px;
}
.task-font-bk2-3 {
  position: absolute;
  z-index: 100;
  width: 80px;
  height: 81px;
  margin: 139px 0px 0px 240px;
}
.task-font-bk2-4 {
  position: absolute;
  z-index: 100;
  width: 80px;
  height: 81px;
  margin: 139px 0px 0px 354px;
}
.task-font-bk3-1 {
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 26px;
	right: 290px;
}
.baojingxinxi {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 26px;
	right: 240px;
}
.task-font-bk5-1 {
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 26px;
  margin: 255px 0px 0px 0px;
	right: 290px;
}
.renwuqushi {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 26px;
  margin: 255px 0px 0px 15px;
	right: 240px;
}

// ------------------
// -----数据部分------
.chulichang-item-1 {
  position: absolute;
  width: 60px;
  height: 17px;
  font-size: 16px;
 
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 228px 0px 0px 30px;
  .num {
    width: 48px;
    height: 16px;
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #ffde00;
    line-height: 17px;
    margin: -80px 0px 0px 0px;
  }
}
.chulichang-item-2 {
  position: absolute;
  width: 60px;
  height: 17px;
  font-size: 16px;
 
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 228px 0px 0px 145px;
  .num {
    width: 48px;
    height: 16px;
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #ffde00;
    line-height: 17px;
    margin: -80px 0px 0px 0px;
  }
}
.chulichang-item-3 {
  position: absolute;
  width: 60px;
  height: 17px;
  font-size: 16px;
 
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 228px 0px 0px 256px;
  .num {
    width: 48px;
    height: 16px;
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #ffde00;
    line-height: 17px;
    margin: -80px 0px 0px 0px;
  }
}
.chulichang-item-4 {
  position: absolute;
  width: 60px;
  height: 17px;
  font-size: 16px;
 
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 228px 0px 0px 368px;
  .num {
    width: 48px;
    height: 16px;
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #ffde00;
    line-height: 17px;
    margin: -80px 0px 0px 0px;
  }
}

// ------------------
.chart {
  background: #0023707e;
  width: 418px;
  height: 225px;
  margin: 315px 0px 0px 10px;
  padding: 0px 0px 0px 0px;
  border-radius: 8px;
  #chartData {
    width: 100%;
    height: 220px;
  }
}
.chart-empty {
  background: #002370e0;
  width: 418px;
  height: 311px;
  margin: 738px 0px 0px 30px;
  padding: 30px 0px 0px 0px;
  border-radius: 8px;
  color: rgb(87, 87, 87);
  font-size: 28px;
  font-weight: bold;
  font-style: italic;
}
.table-style {
  position: absolute;
  width: 418px;
  height: 195px;
  border-radius: 4px;
  background: #003caf66;
  // opacity: 0.7;
  z-index: 100;
  margin: 40px 0px 0px 10px;
}
// 去掉单元格白线边框
.table-style >>> th {
  border: none;
}
.table-style >>> td,
.table-style >>> th.is-leaf {
  border: none;
}
// 表格最外层边框-底部边框
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.table-style::before {
  width: 0;
}
.table-style .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
// // 头部边框
// .table-style thead tr th.is-leaf{
//   border: 1px solid #EBEEF5;
//   border-right: none;
// }
// .table-style thead tr th:nth-last-of-type(2){
//   border-right: 1px solid #EBEEF5;
// }
//@import url(); 引入公共css类
</style>
<style lang='scss'>
// // 去掉单元格白线边框
// .table-style th{
//     border:none;
//   }
// .table-style td,.table-style th.is-leaf {
//   border:none;
// }
// // 表格最外层边框-底部边框
// .el-table--border::after, .el-table--group::after{
//   width: 0;
// }
// .table-style::before{
//   width: 0;
// }
// .table-style .el-table__fixed-right::before,.el-table__fixed::before{
//   width: 0;
// }
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/mod_screen_display_show/rightDataDisplay.vue